var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogoTeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.84 381.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00857c;stroke-miterlimit:10;stroke-width:15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.71,
    y: 130.18,
    width: 76.77,
    height: 243.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.68,
    cy: 51.68,
    r: 44.18,
    transform: "translate(-9.77 12.12) rotate(-12.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.43,122.94c-59.39,0-76.28,40.56-76.28,40.56v-33.31h-73.87v243.33h76.77v-127.46c0-17.38,5.31-56.49,44.9-56.49s39.59,45.87,39.59,45.87v138.08h75.8V229.16c0-68.56-27.52-106.22-86.91-106.22Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogoTeal);
export default __webpack_public_path__ + "static/media/linkedin-logo-teal.164d325a17f13c10c0e8b9ed429c3536.svg";
export { ForwardRef as ReactComponent };